import React, { useEffect, useState } from 'react'
import { Outlet, useNavigate } from "react-router-dom";
import CardMedicines from '../../../components/CardMedicines';
import Filter from './../../../components/Filter';
import { useSelector } from 'react-redux';
import { message, Pagination, Spin } from 'antd';
import axios from 'axios';

function Medicines() {
  const API_URL = import.meta.env.VITE_API_URL;
  const [Medicines, setMedicines] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0 });
  const [loading, setLoading] = useState(false);
  const accessToken = useSelector((state) => state.user.accessToken);
  const [selectedFilters, setSelectedFilters] = useState({ status: null, search: null });
  const userType = useSelector((state) => state.user?.user?.roleDetails?.id);
  const [FlagFetch, setFlagFetch] = useState(0);

  const handleDelete = (deletedId) => {
    setMedicines(prevMedicines => prevMedicines.filter(medicine => medicine.id !== deletedId));
    setPagination(prev => ({
      ...prev,
      total: prev.total - 1
    }));
  };

  const fetchMedicines = async (page = 1, pageSize = 5, Type = null, search = null) => {
    setLoading(true);
    try {
      // Construct query parameters
      const params = {
        page: page,
        limit: pageSize,
        type: Type ? Type : undefined,
        search: search || undefined,
      };

      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([_, value]) => value !== undefined)
      );

      const response = await axios.get(`${API_URL}Medicines/get-medicines`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: filteredParams,
      });

      const { totalCount } = response.data;
      setMedicines(response.data.medicines);
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
        total: totalCount,
      });
    } catch (error) {
      message.destroy();
      console.error("Error fetching medicines:", error);
      message.error('Failed to fetch medicines');
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    let updatedFilters = { ...selectedFilters };
    let errorMessageShown = false;

    if (key === "Type") {
      updatedFilters.Type = value;
    }

    if (key === "search") {
      let search = null;

      if (value && value.trim().length > 0) {
        const searchValue = value.trim();

        if (/\d/.test(searchValue)) {
          message.destroy();
          message.error("Search term must not contain numbers.");
          errorMessageShown = true;
        } else if (searchValue.length > 2) {
          search = searchValue;
        }
      }

      updatedFilters.search = search;
    }

    if (key === "") {
      updatedFilters = {};
    }

    setSelectedFilters(updatedFilters);

    if (!errorMessageShown) {
      fetchMedicines(1, pagination.pageSize, updatedFilters.Type, updatedFilters.search);
    }
  };

  const handlePaginationChange = (page, pageSize) => {
    setPagination(prev => ({
      ...prev,
      current: page,
      pageSize: pageSize
    }));
    fetchMedicines(page, pageSize, selectedFilters.Type, selectedFilters.search);
  };

  // Initial fetch and when FlagFetch changes
  useEffect(() => {
    fetchMedicines(pagination.current, pagination.pageSize, selectedFilters.Type, selectedFilters.search);
  }, [FlagFetch]);

  const filterDropdowns = [
    {
      title: 'Type',
      options: [
        'Capsule', 'Tablet', 'Cream', 'Syrup', 'Drops', 'Inhalers', 'Injections',
        'Tablets', 'Capsules', 'Ointmaint', 'Eye drops', 'Ear drops', 'Sachets',
        'Spray', 'Suppsitory', 'Facial wash', 'Gel', 'Lotion', 'Caplets', 'Ampoules',
        'Soap', 'Hair oil', 'Suspention', 'Vaginal Suppsitory', 'Vaginal Gel',
        'Oral Drops', 'Shampoo', 'Vial', 'Infusion', 'Cartiridges', 'Prefilled pen',
        'Powder', 'Inhaler', 'Eye OINT', 'Serum', 'Mouth wash', 'Nasal drops',
        'SOLUTION', 'Vaginal Douch', 'Gummies', 'Chewable', 'LOZENGES', 'Effervescent',
        'Vaginal cream', 'Eye ointmaint', 'Eye gel', 'Conditioner', 'Foam', 'PENFILLS',
        'PREFILLED SYRINGE', 'PATCHES', 'LUBRICANT', 'WHITENING WASH', 'FACIAL CLEANSER',
        'FILM', 'FLEXPEN', 'POUCHES', 'NASAL SPRAY', 'HAIR MASK', 'SHEETS'
      ]
    }
  ];

  const [filterOptions, setFilterOptions] = useState({});

  return (
    <>
      <div className="space-y-5">
        {userType == 4 ?
          <Filter
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
            dropdowns={filterDropdowns}
            addItemUrl="AddMedicines"
            searchBarPlaceholder="Search Medicines"
            onFilterChange={handleFilterChange}
          /> :
          <Filter
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
            dropdowns={filterDropdowns}
            addItemName="Add Medication"
            addItemUrl="AddMedicines"
            searchBarPlaceholder="Search Medicines"
            onFilterChange={handleFilterChange}
          />}
        <Spin spinning={loading}>
          {Medicines.map((medicine) => (
            <CardMedicines
              key={medicine.id}
              data={medicine}
              onDelete={handleDelete}
            />
          ))}
        </Spin>
        <Pagination
          current={pagination.current}
          pageSize={pagination.pageSize}
          total={pagination.total}
          onChange={handlePaginationChange}
          showSizeChanger
          onShowSizeChange={handlePaginationChange}
        />
      </div>
      <Outlet />
    </>
  );
}

export default Medicines;